export default {
  GET_RECITERS: 'GET_RECITERS'
}



// WEBPACK FOOTER //
// ./src/Reciters/actionTypes.js